// ─── An article and the company's own report (sprint 21, stage 3) ──────────
//
// A news article about a company the user holds or watches, and an 8-K (or
// 6-K) of the same company filed within MATCH_DAYS of it: the article's
// window shows what the report said ("בדיווח הרשמי של החברה ל-SEC"). The
// company is the article's own match (utils/newsMatch.js portfolioMatches),
// not a mention in the body. Several reports in the window: the nearest.

export const MATCH_DAYS = 2;
const dayMs = 86400000;

// Days between two moments on the New York calendar, not counting Saturdays
// and Sundays: a Friday report and Monday's article are one day apart.
const nyDay = t => new Date(t).toLocaleDateString("en-CA", { timeZone: "America/New_York" });
export function tradingDayGap(a, b) {
  let [x, y] = [Math.min(a, b), Math.max(a, b)].map(nyDay);
  let n = 0;
  for (let d = Date.parse(`${x}T12:00:00Z`), end = Date.parse(`${y}T12:00:00Z`); d < end; d += dayMs) {
    const wd = new Date(d + dayMs).getUTCDay();
    if (wd !== 0 && wd !== 6) n += 1;
  }
  return n;
}

// A report's day on the SEC's calendar, as a moment: noon in New York.
const filedAt = f => Date.parse(`${f.filed_date}T16:00:00Z`);

/**
 * article · { datetime } in seconds (Finnhub) · symbols · the companies the
 * article is about · filings · sec_filings rows with a checked summary.
 * → the matching report, or null.
 */
export function filingForArticle(article, symbols, filings) {
  const t = Number(article?.datetime) * 1000;
  if (!Number.isFinite(t) || !symbols?.length || !filings?.length) return null;
  const set = new Set(symbols);
  return filings
    .filter(f => set.has(f.symbol) && Array.isArray(f.summary) && f.summary.length)
    .map(f => ({ f, abs: Math.abs(filedAt(f) - t) }))
    // Far apart on the calendar is far apart in trading days too · the day
    // count (Intl, a loop) only for the few that are near.
    .filter(x => x.abs <= (MATCH_DAYS + 4) * dayMs)
    .map(x => ({ ...x, gap: tradingDayGap(filedAt(x.f), t) }))
    .filter(x => x.gap <= MATCH_DAYS)
    .sort((a, b) => a.gap - b.gap || a.abs - b.abs)[0]?.f || null;
}
